<script>
export default {
  props: {
    icon: {
      type: String,
      default: "icon-nodata",
    },
    text: {
      type: String,
      default: "暂无数据",
    },
  },
  render() {
    let iconContent = <i class={"iconfont " + this.icon} />;
    if (this.$slots.icon) {
      iconContent = this.$slots.icon;
    }

    let textContent = this.text;
    if (this.$slots.text) {
      textContent = this.$slots.text;
    }

    return (
      <div class="nodata">
        <div>{iconContent}</div>
        <div class="text">{textContent}</div>
      </div>
    );
  },
};
</script>
<style lang="less" scoped>
.nodata {
  text-align: center;
  font-size: 0.4rem;
  padding: 50px 0;

  i {
    font-size: 80px;
    color: #999;
  }
  .text {
    font-size: 0.3rem;
    color: #999;
    margin-top: 1rem;
  }
}
</style>
